import { Box, CircularProgress, Container, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BarraBusqueda } from "../../common/Behelit/BarraBusqueda";
import RevisorService from "../../services/RevisorService";
import { GetVoidPaginateObj, PaginateObj } from "../../types/Paginate/PaginateObjt";
import { ItemRevisor } from "../../types/Revisor/ItemRevisor";
import { RevisorTable } from "../../componente/Revisor/RevisorTable";
import { themePalette } from "../../config/theme.config";

export const BandejaRevisorPage: React.FC<{}> = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [tab, setTab] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState<PaginateObj<ItemRevisor>>(GetVoidPaginateObj());
    // Function
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
        //console.log(newValue);
    };
    const handleSearchChange = (value: string) => {
        setSearch(value);
    };
    const estadoAnuncios = (tab: number) => {
        let est = 'P';
        switch(tab){
            case 1:
                est = 'A';
                break;
            case 2:
                est = 'U';
                break;
            default:
                break;
        }
        return est;
    }
    const fetchAnuncios = async () => {
        setLoading(true)
        try {
            const response = await RevisorService.GetAnunciosParaRevisor(estadoAnuncios(tab));
            const data = response;
            // console.log(data);
            if (response.succeeded) {
                setPage(data);
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    const fetchAnunciosByTitle = async () => {
        setLoading(true)
        try {
            const response = await RevisorService.GetAnunciosParaRevisorSearch(estadoAnuncios(tab),search);
            const data = response;
            // console.log(data);
            if (response.succeeded) {
                setPage(data);
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    // effect
    useEffect(() => {
        fetchAnuncios();
    }, []);
    useEffect(() => {
        fetchAnuncios();
    }, [tab]);
    useEffect(() => {
        if(search.length === 0){
            fetchAnuncios();
        }
        if(search.length < 3) return;
        const debounce = setTimeout(() => {
            fetchAnunciosByTitle();
        },500)
        function cleanup(){
            clearTimeout(debounce)
        }
    },[search])
    return (
        <Container maxWidth="lg" style={{ padding: '20px', textAlign: 'center', marginTop: 10, border: `1px solid ${themePalette.NAVCOLOR}`, borderTopWidth: '3px', borderRadius: '5px' }}>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="h4" gutterBottom style={{ fontWeight: 'bold', paddingBottom: '1%', color: `${themePalette.NAVCOLOR}` }}>
                    APROBACIÓN COMUNICADOS
                </Typography>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Tabs
                    value={tab}
                    onChange={handleTabChange}
                    aria-label="Pestañas interactivas"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Pendientes" id="tab-0" aria-controls="tabpanel-0" />
                    <Tab label="Aprobados" id="tab-1" aria-controls="tabpanel-1" />
                    <Tab label="Publicados" id="tab-2" aria-controls="tabpanel-2" />
                </Tabs>
            </Box>
            <Box sx={{ display: 'flex' }}>
                <BarraBusqueda id={"busqueda"} customStyles={{ m: 1, width: '100%' }} input={search} onChange={handleSearchChange} />
            </Box>
            <Box sx={{ display: 'flex' }}>
                <Grid container spacing={2}>
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <RevisorTable page={page} />
                    )}
                </Grid>
            </Box>
        </Container>
    )
}